import React from 'react';
import { BaseModal } from '../comun/Index';
import Personas from '../mesa/Personas';
import axios from 'axios'

const getLocalidades = function(){
  return new Promise(function(resolve, reject) {
    axios.get(localStorage.getItem('apiUrl') + '/localidades/listar/')
    .then((res) =>{
      if (res.data.status === "ok"){
        resolve(res.data.localidades)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

export default class ModalPase extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      localidades:[]
    }
  }
  componentDidMount(){
    getLocalidades()
    .then((localidades) => this.setState({localidades}))
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error")
    })
  }

  render(){
    const {localidades} = this.state;
    const {datosPersonas, editar, guardar, salir} = this.props;
    return(
    <BaseModal
      titulo="Agregar personas"
      loading={false}
      botonera={[
        {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => salir()},
        {titulo:"Guardar", backgroundColor:'#00B845', onClick: () => guardar()}
      ]}
    >
      <Personas
        localidades={localidades}
        datos={datosPersonas}
        editar={(campo, valor) => editar(campo, valor)}
      />
    </BaseModal>
    )
  }
}